import React from 'react';
import { BlurFade } from '../magicui/blur-fade';

const steps = [
  { n: '01', title: 'Listen', text: 'We study the everyday tasks that waste people’s time and find the friction worth removing.' },
  { n: '02', title: 'Design', text: 'We shape the simplest possible experience — fewer screens, clearer choices, sensible defaults.' },
  { n: '03', title: 'Engineer', text: 'We build native, efficient software that runs locally and handles real-world volumes reliably.' },
  { n: '04', title: 'Support', text: 'We keep improving after launch, guided by feedback from the people who use our products.' },
];

export default function Approach() {
  return (
    <section className="bg-mist py-24 lg:py-32">
      <div className="container-x">
        <div className="mx-auto max-w-2xl text-center">
          <BlurFade inView>
            <p className="eyebrow justify-center">How we work</p>
          </BlurFade>
          <BlurFade inView delay={0.1}>
            <h2 className="h-section mt-5">From everyday friction to finished product.</h2>
          </BlurFade>
        </div>
        <ol className="mt-16 grid gap-px overflow-hidden rounded-3xl bg-line shadow-card sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <li key={s.n} className="bg-white">
              <BlurFade inView delay={0.08 * i} className="h-full p-8">
                <span className="fusion-text font-display text-5xl font-semibold tracking-[-0.04em]">{s.n}</span>
                <h3 className="mt-6 font-display text-xl font-semibold">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink-3">{s.text}</p>
              </BlurFade>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
